import { render, staticRenderFns } from "./SectionRejectModal.vue?vue&type=template&id=7a6f313c&scoped=true&"
import script from "./SectionRejectModal.vue?vue&type=script&lang=js&"
export * from "./SectionRejectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f313c",
  null
  
)

export default component.exports